import { dataLayerPush } from '@libs/analytics';

import type { ProfileCompletionReturnTo, ProfileCompletionStepId } from './constants';
import { safeGet, safeRemove, safeSet } from './safe-session-storage';

export const START_PROFILE_STEPPER_EVENT_KEY = 'profileCompleteStartStepperEvent';

const ENTRY_POINT_BY_STEP = {
    pet: 'pet',
    address: 'address',
    notifications: 'opt-in',
} as const;

type StartProfileStepperEntryPoint = (typeof ENTRY_POINT_BY_STEP)[ProfileCompletionStepId];

type StartProfileStepperEvent = {
    event: 'start_profile_stepper';
    site_section: 'treats rewards' | 'about you';
    entry_point: StartProfileStepperEntryPoint;
};

function isStartProfileStepperEvent(value: unknown): value is StartProfileStepperEvent {
    if (!value || typeof value !== 'object') {
        return false;
    }

    const event = value as StartProfileStepperEvent;
    return (
        event.event === 'start_profile_stepper' &&
        (event.site_section === 'treats rewards' || event.site_section === 'about you') &&
        (event.entry_point === 'pet' || event.entry_point === 'address' || event.entry_point === 'opt-in')
    );
}

export function stageStartProfileStepperEvent(
    returnTo: ProfileCompletionReturnTo,
    step: ProfileCompletionStepId
): void {
    const event: StartProfileStepperEvent = {
        event: 'start_profile_stepper',
        site_section: returnTo === 'treats' ? 'treats rewards' : 'about you',
        entry_point: ENTRY_POINT_BY_STEP[step],
    };
    safeSet(START_PROFILE_STEPPER_EVENT_KEY, JSON.stringify(event));
}

export function clearStagedStartProfileStepperEvent(): void {
    safeRemove(START_PROFILE_STEPPER_EVENT_KEY);
}

export function publishStagedStartProfileStepperEvent(): void {
    const raw = safeGet(START_PROFILE_STEPPER_EVENT_KEY);
    if (!raw) {
        return;
    }

    clearStagedStartProfileStepperEvent();

    try {
        const event: unknown = JSON.parse(raw);
        if (!isStartProfileStepperEvent(event)) {
            return;
        }
        dataLayerPush(event);
    } catch {
        // Ignore malformed payloads left in sessionStorage.
    }
}
